import { getPipelineStageId } from "../../pipeline/selectors/getPipelineStageId.js";
import { INVOICE_PAYMENT_STATUS_PIPELINE } from "../../payment/index.js";
import { getPipelineByName } from "../../pipeline/selectors/getPipelineByName.js";
import { getOrdersInPipelineStage } from "./getOrdersInPipelineStage.js";
export const getOrdersInDebtCollection = async ({ customerIdentifier }, { client }) => {
    const stageId = await getPipelineStageId({
        pipelineName: INVOICE_PAYMENT_STATUS_PIPELINE.NAME,
        stageName: INVOICE_PAYMENT_STATUS_PIPELINE.STAGES.DEBT_COLLECTION,
    }, { client });
    const invoicePipeline = await getPipelineByName({ pipelineName: INVOICE_PAYMENT_STATUS_PIPELINE.NAME }, { client });
    return await getOrdersInPipelineStage({
        pipelineId: invoicePipeline.id ?? "",
        pipelineStageId: stageId ?? "",
        customerIdentifier,
    }, { client });
};
